<template>
    <v-layout row wrap v-redirect-if-no-permission:REGISTERED_CAPTAINS>
        <loading-component :value="loading"/>
        <v-dialog :value="!!activeEvent" @input="activeEvent = null" max-width="50%">
            <v-card>
                <v-card-text class="title ">
                    Do you want to delete this shift?
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="activeEvent = null">Cancel</v-btn>
                    <v-btn color="red" @click="deleteEvent">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-flex sm12>
            <full-calendar
                    ref="calendar"
                    default-view="timeGridWeek"
                    :events="events"
                    :event-overlap="false"
                    :droppable="false"
                    :editable="true"
                    :selectable="true"
                    :all-day-slot="false"
                    slot-duration="00:15:00"
                    event-order="start"
                    :plugins="calendarPlugins"
                    @select="select"
                    @eventDrop="eventDrop"
                    @eventClick="({event}) => activeEvent = event"
                    @eventResize="eventResize"/>
        </v-flex>
    </v-layout>

</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import FullCalendar from "@fullcalendar/vue";
    import FullCalendarTimeGrid from "@fullcalendar/timegrid";
    import FullCalendarInteraction from "@fullcalendar/interaction";
    import moment from "moment";


    export default {
        props: {
            captainId: {
                type: Number,
                required: true
            }
        },
        components: {LoadingComponent, FullCalendar},
        name: "schedule",
        data() {
            return {
                date: null,
                loading: false,
                events: [],
                activeBooking: null,
                activeEvent: null,
                sliceInfoDialog: false,
                slice: null
            }
        },
        computed: {
            calendarPlugins() {
                return [FullCalendarTimeGrid, FullCalendarInteraction];
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get(this.api.ACTIONS.CAPTAIN_SCHEDULE(this.captainId))
                .then(
                    ({data: {data}}) => {
                        for (let event of data)
                            this.addEvent(event);
                    }
                )
                .finally(
                    () => this.loading = false
                )
        },
        methods: {
            eventDrop({event, revert}) {
                if (moment(event.start).format("YYYY-MM-DD") !== moment(event.end).format("YYYY-MM-DD")) {
                    revert();
                    return;
                }
                this.loading = true;
                const start_hour = moment(event.start).format("HH:mm");
                const end_hour = moment(event.end).format("HH:mm");
                const day_id = moment(event.start).day() + 1;
                this.axios.put(this.api.ACTIONS.CAPTAIN_SCHEDULE(this.captainId) + '/' + event.id, {
                    start_hour,
                    end_hour,
                    day_id
                })
                    .catch(
                        revert
                    )
                    .finally(
                        () => this.loading = false
                    )
            },
            deleteEvent() {
                this.loading = true;
                this.axios.delete(this.api.ACTIONS.CAPTAIN_SCHEDULE(this.captainId) + '/' + this.activeEvent.id)
                    .then(
                        () => this.activeEvent.remove()
                    )
                    .finally(
                        () => {
                            this.activeEvent = null;
                            this.loading = false
                        }
                    )
            },
            eventResize({event, revert}) {
                if (moment(event.start).format("YYYY-MM-DD") !== moment(event.end).format("YYYY-MM-DD")) {
                    revert();
                    return;
                }
                this.loading = true;
                const start_hour = moment(event.start).format("HH:mm");
                const end_hour = moment(event.end).format("HH:mm");
                const day_id = moment(event.start).day() + 1;
                this.axios.put(this.api.ACTIONS.CAPTAIN_SCHEDULE(this.captainId) + '/' + event.id, {
                    start_hour,
                    end_hour,
                    day_id
                })
                    .catch(
                        revert
                    )
                    .finally(
                        () => this.loading = false
                    )

            },
            addEvent(data) {
                const dataEvent = {
                    id: data.id,
                    title: "Available",
                    start: moment().startOf('week').add(data.day_id - 1, 'days').add(data.start_hour.split(":")[0], 'hours').add(data.start_hour.split(":")[1], "minutes").toDate(),
                    end: moment().startOf('week').add(data.day_id - 1, 'days').add(data.end_hour.split(":")[0], 'hours').add(data.end_hour.split(":")[1], "minutes").toDate(),
                    customButtons: {
                        myCustomButton: {
                            text: 'custom!',
                            click: () => {
                                alert('clicked the custom button!');
                            }
                        }
                    }
                };
                this.events = [...this.events, dataEvent];
            },
            select(info) {
                const {startStr, endStr} = info;
                if (moment(startStr).format("YYYY-MM-DD") === moment(endStr).format("YYYY-MM-DD")) {
                    const start_hour = moment(startStr).format("HH:mm");
                    const end_hour = moment(endStr).format("HH:mm");
                    const day_id = moment(startStr).day() + 1;
                    this.loading = true;
                    this.axios.post(this.api.ACTIONS.CAPTAIN_SCHEDULE(this.captainId), {start_hour, end_hour, day_id})
                        .then(
                            ({data: {data}}) => this.addEvent(data)
                        )
                        .finally(
                            () => this.loading = false
                        )
                } else {
                    alert('must be on same day');
                }
            }
        }
    }
</script>

<style scoped>
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/timegrid/main.css';

    div >>> .fc-toolbar.fc-header-toolbar {
        display: none;
    }

    .removebtn {
        color: black;
        position: absolute;
        top: 0;
        right: 0;
        width: 13px;
        height: 13px;
        text-align: center;
        border-radius: 50%;
        font-size: 10px;
        cursor: pointer;
        background-color: #FFF
    }
</style>